import { axiosApi } from "../axios";
import { FeedbackState } from "../types/feedback";

export const sendFeedback = async (body: FeedbackState) => {
  await axiosApi.post("/feedback", body);

  return { success: true };
};
